export default __webpack_public_path__ + "static/media/POPPINS-BLACK.27b02993.TTF";